export enum ColourCardTypes {
  Warning,
  Success,
  Blue,
  Danger,
}
